var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBugeypath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6176",
    "data-name": "Group 6176",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 12.713,
    viewBox: "0 0 16.5 12.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M52.25,806.4l2.25,3v3.75H53a2.25,2.25,0,0,1-4.5,0H44a2.25,2.25,0,0,1-4.5,0H38V804.9a1.538,1.538,0,0,1,1.5-1.5H50v3Zm-11.325,7.575a1.284,1.284,0,1,0-.3-.825A1.025,1.025,0,0,0,40.925,813.975Zm9,0a1.284,1.284,0,1,0-.3-.825A1.025,1.025,0,0,0,49.925,813.975Zm1.95-6.45H50V809.4h3.375Z",
    transform: "translate(-38 -802.687)",
    fill: "#fd5634"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 7.5,
    height: 4.5,
    transform: "translate(2.216)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugeypath);
export default __webpack_public_path__ + "static/media/bugeypath.622dcf3cfb9eb0bf86e9ccdae583070f.svg";
export { ForwardRef as ReactComponent };